"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.approveCollectionAuthority = exports.getApproveCollectionAuthorityInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const accounts_1 = require("../accounts");
const shared_1 = require("../shared");
function getApproveCollectionAuthorityInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([['discriminator', (0, serializers_1.u8)()]], { description: 'ApproveCollectionAuthorityInstructionData' }), (value) => ({ ...value, discriminator: 23 }));
}
exports.getApproveCollectionAuthorityInstructionDataSerializer = getApproveCollectionAuthorityInstructionDataSerializer;
// Instruction.
function approveCollectionAuthority(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplTokenMetadata', 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
    // Accounts.
    const resolvedAccounts = {
        collectionAuthorityRecord: {
            index: 0,
            isWritable: true,
            value: input.collectionAuthorityRecord ?? null,
        },
        newCollectionAuthority: {
            index: 1,
            isWritable: false,
            value: input.newCollectionAuthority ?? null,
        },
        updateAuthority: {
            index: 2,
            isWritable: true,
            value: input.updateAuthority ?? null,
        },
        payer: {
            index: 3,
            isWritable: true,
            value: input.payer ?? null,
        },
        metadata: {
            index: 4,
            isWritable: false,
            value: input.metadata ?? null,
        },
        mint: { index: 5, isWritable: false, value: input.mint ?? null },
        systemProgram: {
            index: 6,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
        rent: { index: 7, isWritable: false, value: input.rent ?? null },
    };
    // Default values.
    if (!resolvedAccounts.updateAuthority.value) {
        resolvedAccounts.updateAuthority.value = context.identity;
    }
    if (!resolvedAccounts.payer.value) {
        resolvedAccounts.payer.value = context.payer;
    }
    if (!resolvedAccounts.metadata.value) {
        resolvedAccounts.metadata.value = (0, accounts_1.findMetadataPda)(context, {
            mint: (0, shared_1.expectPublicKey)(resolvedAccounts.mint.value),
        });
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'omitted', programId);
    // Data.
    const data = getApproveCollectionAuthorityInstructionDataSerializer().serialize({});
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.approveCollectionAuthority = approveCollectionAuthority;
//# sourceMappingURL=approveCollectionAuthority.js.map